import { c as _c } from "react-compiler-runtime";
import { Toast as BaseToast } from '@base-ui/react/toast';
import { jsx as _jsx } from "react/jsx-runtime";
const TOAST_PROVIDER_COMPONENT_NAME = 'ToastProvider';
export function ToastProvider(t0) {
  const $ = _c(5);
  const {
    children,
    limit,
    timeout,
    toastManager
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== limit || $[2] !== timeout || $[3] !== toastManager) {
    t1 = /*#__PURE__*/_jsx(BaseToast.Provider, {
      limit: limit,
      timeout: timeout,
      toastManager: toastManager,
      children: children
    });
    $[0] = children;
    $[1] = limit;
    $[2] = timeout;
    $[3] = toastManager;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
ToastProvider.displayName = TOAST_PROVIDER_COMPONENT_NAME;